/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunningMeasurementResponseDto
 */
export interface RunningMeasurementResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RunningMeasurementResponseDto
     */
    streamId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunningMeasurementResponseDto
     */
    measurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof RunningMeasurementResponseDto
     */
    $type?: RunningMeasurementResponseDtoTypeEnum;
}


/**
 * @export
 */
export const RunningMeasurementResponseDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoRunningMeasurementResponseDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.RunningMeasurementResponseDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunningMeasurementResponseDtoTypeEnum = typeof RunningMeasurementResponseDtoTypeEnum[keyof typeof RunningMeasurementResponseDtoTypeEnum];


/**
 * Check if a given object implements the RunningMeasurementResponseDto interface.
 */
export function instanceOfRunningMeasurementResponseDto(value?: unknown): value is RunningMeasurementResponseDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunningMeasurementResponseDtoTypeEnum)[0];
}

export function RunningMeasurementResponseDtoFromJSON(json: any): RunningMeasurementResponseDto {
    return RunningMeasurementResponseDtoFromJSONTyped(json, false);
}

export function RunningMeasurementResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunningMeasurementResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'streamId': !exists(json, 'streamId') ? undefined : json['streamId'],
        'measurementId': !exists(json, 'measurementId') ? undefined : json['measurementId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RunningMeasurementResponseDtoToJSON(value?: RunningMeasurementResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'streamId': value.streamId,
        'measurementId': value.measurementId,
        '$type': value.$type,
    });
}

